export const LIST_AUTOCOMPLETE_TEXT_REQUEST = 'LIST_AUTOCOMPLETE_TEXT_REQUEST'
export const LIST_AUTOCOMPLETE_TEXT_SUCCESS = 'LIST_AUTOCOMPLETE_TEXT_SUCCESS'
export const LIST_AUTOCOMPLETE_TEXT_FAILURE = 'LIST_AUTOCOMPLETE_TEXT_FAILURE'

export const LIST_AUTOCOMPLETE_TEXT_SUMMARY_REQUEST = 'LIST_AUTOCOMPLETE_TEXT_SUMMARY_REQUEST'
export const LIST_AUTOCOMPLETE_TEXT_SUMMARY_SUCCESS = 'LIST_AUTOCOMPLETE_TEXT_SUMMARY_SUCCESS'
export const LIST_AUTOCOMPLETE_TEXT_SUMMARY_FAILURE = 'LIST_AUTOCOMPLETE_TEXT_SUMMARY_FAILURE'

export const CREATE_AUTOCOMPLETE_TEXT_REQUEST = 'CREATE_AUTOCOMPLETE_TEXT_REQUEST'
export const CREATE_AUTOCOMPLETE_TEXT_SUCCESS = 'CREATE_AUTOCOMPLETE_TEXT_SUCCESS'
export const CREATE_AUTOCOMPLETE_TEXT_FAILURE = 'CREATE_AUTOCOMPLETE_TEXT_FAILURE'

export const DETAIL_AUTOCOMPLETE_TEXT_REQUEST = 'DETAIL_AUTOCOMPLETE_TEXT_REQUEST'
export const DETAIL_AUTOCOMPLETE_TEXT_SUCCESS = 'DETAIL_AUTOCOMPLETE_TEXT_SUCCESS'
export const DETAIL_AUTOCOMPLETE_TEXT_FAILURE = 'DETAIL_AUTOCOMPLETE_TEXT_FAILURE'

export const UPDATE_AUTOCOMPLETE_TEXT_REQUEST = 'UPDATE_AUTOCOMPLETE_TEXT_REQUEST'
export const UPDATE_AUTOCOMPLETE_TEXT_SUCCESS = 'UPDATE_AUTOCOMPLETE_TEXT_SUCCESS'
export const UPDATE_AUTOCOMPLETE_TEXT_FAILURE = 'UPDATE_AUTOCOMPLETE_TEXT_FAILURE'

export const DELETE_AUTOCOMPLETE_TEXT_REQUEST = 'DELETE_AUTOCOMPLETE_TEXT_REQUEST'
export const DELETE_AUTOCOMPLETE_TEXT_SUCCESS = 'DELETE_AUTOCOMPLETE_TEXT_SUCCESS'
export const DELETE_AUTOCOMPLETE_TEXT_FAILURE = 'DELETE_AUTOCOMPLETE_TEXT_FAILURE'

export const RESET_STATE_AUTOCOMPLETE_TEXT = 'RESET_STATE_AUTOCOMPLETE_TEXT'

